const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="service-card text-center h-100">
      <div className="service-icon">{icon}</div>
      <h4 className="service-title">{title}</h4>
      <p className="service-text">{description}</p>
    </div>
  );
};

export default ServiceCard;
